import { createTheme } from '@mui/material';

export const dark = createTheme();
